module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "covered-car.983ea8d1.png" + "?" + Date.now();